import { render, staticRenderFns } from "./ProfissionalIndependenteForm.vue?vue&type=template&id=207cb185"
import script from "./ProfissionalIndependenteForm.vue?vue&type=script&lang=js"
export * from "./ProfissionalIndependenteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports